module.exports = __webpack_public_path__ + "media/components/page-header/static/icon-home-718e599a95f8d9469a452fffe12da877.svg";